module.exports = __webpack_public_path__ + "downloadProfistopBrochure.png?d0d610859ff6331b9a4370891900fc14";